import { Controller } from "@hotwired/stimulus"

// Pops the post-RSVP confirmation open on page load.
//
// The dialog deliberately ships without an `open` attribute so it cannot flash
// inline before Stimulus connects; that also means a browser without <dialog>
// support never shows it, which is fine — the same confirmation is rendered
// into the page behind it (see events/_rsvp_confirmation.html.erb).
export default class extends Controller {
  connect() {
    if (typeof this.element.showModal !== "function") return

    // showModal() throws if the dialog is already open, which it can be when
    // Turbo restores a cached page.
    if (this.element.open) this.element.close()
    this.element.showModal()
  }

  close() {
    this.element.close()
  }
}
